<div class="space-y-6 max-w-[1280px] mx-auto px-4 sm:px-6 md:px-8 py-8 min-h-screen bg-background font-sans" id="wizard-view-root">
  
  <div class="loader-overlay flex justify-center py-10" *ngIf="loading">
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>

  <ng-container *ngIf="!loading">
    <!-- Title Header -->
<div class="partner-page-header">

  <div class="partner-title-row">

    <button
      type="button"
      class="back-btn"
      (click)="goBack()"
      aria-label="Go back">

      <span class="material-symbols-outlined">
        arrow_back
      </span>

    </button>

    <h2 class="font-display font-bold text-2xl text-primary tracking-tight m-0">
      Onboarding & Criteria Wizard
    </h2>

  </div>

  <p class="text-secondary text-sm m-0 mt-1 partner-page-description">
    Fine-tune your matchmaking algorithm to scan verified profiles matching your core requirements.
  </p>

</div>

    <div class="partner-layout grid grid-cols-1 lg:grid-cols-4 gap-6 items-start mt-6">
      
      <!-- Left Side Stepper Navigation (Vertical List for desktop, smooth tabs) -->
      <!-- Stepper Navigation -->
<div class="partner-stepper lg:col-span-1 bg-white p-4 rounded-3xl border border-primary/5 shadow-sm">

  <div class="text-[15px] uppercase font-mono tracking-wider font-bold text-secondary mb-3 px-2">
    Match Parameters
  </div>

  <!-- Mobile horizontal stepper -->
  <div class="mobile-stepper">

    <!-- Left Arrow -->
    <button
      type="button"
      class="stepper-arrow"
      (click)="previousStep()"
      [disabled]="activeStep === 0"
      aria-label="Previous step">
      <span class="material-symbols-outlined">chevron_left</span>
    </button>

    <!-- Scrollable steps -->
    <div class="mobile-stepper-scroll" #stepperScroll>

      <button
        *ngFor="let step of steps; let idx = index"
        type="button"
        class="mobile-step"
        [ngClass]="{
          'active': activeStep === idx,
          'completed': idx < activeStep
        }"
        (click)="goToStep(idx)"
      >

        <div class="mobile-step-icon">
          <span class="material-symbols-outlined">
            {{ step.icon }}
          </span>
        </div>

        <div class="mobile-step-text">
          <div class="mobile-step-label">
            {{ step.label }}
          </div>

          <div class="mobile-step-subtitle">
            {{ step.subtitle }}
          </div>
        </div>

      </button>

    </div>

    <!-- Right Arrow -->
    <button
      type="button"
      class="stepper-arrow"
      (click)="nextStep()"
      [disabled]="activeStep === steps.length - 1"
      aria-label="Next step">
      <span class="material-symbols-outlined">chevron_right</span>
    </button>

  </div>

  <!-- Desktop stepper -->
  <div class="desktop-stepper">

    <button
      *ngFor="let step of steps; let idx = index"
      (click)="goToStep(idx)"
      class="w-full text-left p-3 rounded-xl flex items-center gap-3 transition-all border-0"
      [ngClass]="activeStep === idx
        ? 'bg-primary text-white shadow-md shadow-primary/10 font-medium scale-102'
        : (idx < activeStep
          ? 'text-primary bg-primary-fixed/30 hover:bg-primary-fixed/40'
          : 'text-secondary hover:bg-secondary-container/30 bg-transparent')"
    >

      <div
        class="h-8 w-8 rounded-lg flex items-center justify-center text-xs font-bold"
        [ngClass]="activeStep === idx
          ? 'bg-white text-primary'
          : (idx < activeStep
            ? 'bg-primary text-white'
            : 'bg-secondary-container text-secondary')"
      >
        <span class="material-symbols-outlined text-[18px]">
          {{ step.icon }}
        </span>
      </div>

      <div>
        <div class="text-sm font-semibold leading-none">
          {{ step.label }}
        </div>

        <div
          class="text-[12px] mt-0.5"
          [ngClass]="activeStep === idx
            ? 'text-white/80'
            : 'text-secondary/70'"
        >
          {{ step.subtitle }}
        </div>
      </div>

    </button>

  </div>

</div>

      <!-- Right Side Form Content Window -->
      <div class="partner-form lg:col-span-3 bg-white p-5 sm:p-6 rounded-3xl border border-primary/5 shadow-sm space-y-6">
        <div class="partner-form-header pb-3 border-b border-secondary/5 flex items-center justify-between gap-3">
          <h3 class="font-display font-semibold text-base text-primary m-0">
            Step {{ activeStep + 1 }} of 7: {{ steps[activeStep].label }} ({{ steps[activeStep].subtitle }})
          </h3>
          <span class="text-[15px] uppercase font-mono bg-primary-fixed text-primary px-2.5 py-0.5 rounded-full font-bold">
            {{ percentComplete }}% Complete
          </span>
        </div>

        <!-- Conditional Step Content Forms -->
        <div class="min-h-[220px]" id="wizard-form-container">
          
          <!-- Step 1: Basic Criteria -->
          <div *ngIf="activeStep === 0" class="grid grid-cols-1 sm:grid-cols-2 gap-5 animate-fadeIn">
            <div>
              <label class="block text-xs font-semibold text-secondary mb-2">Minimum Desired Age</label>
              <input
                type="number"
                [(ngModel)]="formData.minAge"
                class="w-full bg-secondary-container/20 border border-secondary/15 rounded-xl px-3 py-2 text-xs focus:ring-1 focus:ring-primary outline-none"
                placeholder="e.g. 21"
                min="18"
                max="60"
              />
            </div>
            <div>
              <label class="block text-xs font-semibold text-secondary mb-2">Maximum Desired Age</label>
              <input
                type="number"
                [(ngModel)]="formData.maxAge"
                class="w-full bg-secondary-container/20 border border-secondary/15 rounded-xl px-3 py-2 text-xs focus:ring-1 focus:ring-primary outline-none"
                placeholder="e.g. 28"
                min="18"
                max="60"
              />
            </div>
            <div>
              <label class="block text-xs font-semibold text-secondary mb-2">Minimum Height Preference (cm)</label>
              <input
                type="number"
                [(ngModel)]="formData.minHeight"
                class="w-full bg-secondary-container/20 border border-secondary/15 rounded-xl px-3 py-2 text-xs focus:ring-1 focus:ring-primary outline-none"
                placeholder="e.g. 150"
              />
            </div>
            <div>
              <label class="block text-xs font-semibold text-secondary mb-2">Maximum Height Preference (cm)</label>
              <input
                type="number"
                [(ngModel)]="formData.maxHeight"
                class="w-full bg-secondary-container/20 border border-secondary/15 rounded-xl px-3 py-2 text-xs focus:ring-1 focus:ring-primary outline-none"
                placeholder="e.g. 180"
              />
            </div>
            <div>
              <label class="block text-xs font-semibold text-secondary mb-2">Minimum Weight (kg)</label>
              <input
                type="number"
                [(ngModel)]="formData.minWeight"
                class="w-full bg-secondary-container/20 border border-secondary/15 rounded-xl px-3 py-2 text-xs focus:ring-1 focus:ring-primary outline-none"
                placeholder="e.g. 50"
              />
            </div>
            <div>
              <label class="block text-xs font-semibold text-secondary mb-2">Maximum Weight (kg)</label>
              <input
                type="number"
                [(ngModel)]="formData.maxWeight"
                class="w-full bg-secondary-container/20 border border-secondary/15 rounded-xl px-3 py-2 text-xs focus:ring-1 focus:ring-primary outline-none"
                placeholder="e.g. 80"
              />
            </div>
            <div>
              <label class="block text-xs font-semibold text-secondary mb-2">Marital Status Preferred</label>
              <div class="custom-dropdown">

  <div class="selected-box" (click)="maritalOpen = !maritalOpen">

    {{formData.maritalStatus || 'No Preference'}}

    <span class="arrow material-symbols-outlined">
      expand_more
    </span>

  </div>


  <div class="custom-dropdown-list" *ngIf="maritalOpen">
    <input
 class="search-box"
 placeholder="Search marital status..."
 [(ngModel)]="maritalSearch"
/>
    

    <div class="dropdown-items">

     <div
 class="gender-item"
 *ngFor="let item of filteredMaritalList()"
 (click)="selectMarital(item)">
 {{item}}
</div>
    </div>

  </div>

</div>
            </div>
            <div>
              <label class="block text-xs font-semibold text-secondary mb-2">Physical Status</label>
              <div class="custom-dropdown">

  <div class="selected-box" (click)="physicalOpen = !physicalOpen">

    {{formData.physicalStatus || 'No Preference'}}

    <span class="arrow material-symbols-outlined">
      expand_more
    </span>

  </div>


  <div class="custom-dropdown-list" *ngIf="physicalOpen">
    <input
 class="search-box"
 placeholder="Search physical status..."
 [(ngModel)]="physicalSearch"
/>

    <div class="dropdown-items">

     <div
 class="gender-item"
 *ngFor="let item of filteredPhysicalList()"
 (click)="selectPhysical(item)">
 {{item}}
</div>
    </div>

  </div>

</div>
            </div>
            <div class="sm:col-span-2">
              <label class="block text-xs font-semibold text-secondary mb-2">Family Type</label>
              <div class="custom-dropdown">

  <div class="selected-box" (click)="familyOpen = !familyOpen">

    {{formData.familyType || 'No Preference'}}

    <span class="arrow material-symbols-outlined">
      expand_more
    </span>

  </div>


  <div class="custom-dropdown-list" *ngIf="familyOpen">
    <input
 class="search-box"
 placeholder="Search family type..."
 [(ngModel)]="familySearch"
/>

    <div class="dropdown-items">

      <div
 class="gender-item"
 *ngFor="let item of filteredFamilyList()"
 (click)="selectFamily(item)">
 {{item}}
</div>

    </div>

  </div>

</div>
            </div>
          </div>

          <!-- Step 2: Faith -->
          <div *ngIf="activeStep === 1" class="grid grid-cols-1 sm:grid-cols-1 gap-5 animate-fadeIn">
            <div *ngIf="isNonReligiousUser" class="p-4 bg-emerald-50 border border-emerald-200 rounded-2xl flex items-start gap-3">
              <span class="material-symbols-outlined text-emerald-600 mt-0.5 text-[22px]">public</span>
              <div>
                <h4 class="text-sm font-bold text-emerald-900 m-0">Secular Partner Preference</h4>
                <p class="text-xs text-emerald-800/90 m-0 mt-1 leading-relaxed">
                  Since your profile is marked as <strong>Non-Religious / Secular</strong>, partner religious requirements default to <strong>No Preference / Caste No Bar</strong> to give you open matches across all backgrounds. You can still customize options below if desired.
                </p>
              </div>
            </div>
            <div>
              <label class="block text-xs font-semibold text-secondary mb-2">
  Desired Religion
</label>

<div class="custom-dropdown">

  <div
    class="selected-box"
    (click)="showReligionDropdown = !showReligionDropdown">

    <span>{{ selectedReligionName }}</span>

    <span class="arrow material-symbols-outlined">
      expand_more
    </span>

  </div>

  <div
    class="language-list"
    *ngIf="showReligionDropdown">

    <input
      type="text"
      class="search-box"
      [(ngModel)]="religionSearch"
      placeholder="Search Religion">

    <div class="dropdown-items">

      <div
        class="language-item"
        (click)="formData.religion=''; showReligionDropdown=false">

        No Preference

      </div>

      <div
        class="language-item"
        *ngFor="let rel of filteredReligions()"
        (click)="selectReligion(rel)">

        {{ rel.religion_nme }}

      </div>

    </div>

  </div>

</div>
            </div>
            <div>
              <label class="block text-xs font-semibold text-secondary mb-2">Caste / Sect Specification</label>
              <div class="custom-dropdown">

  <div
    class="selected-box"
    (click)="showCasteDropdown=!showCasteDropdown">

    <span>{{ selectedCasteName }}</span>

    <span class="arrow material-symbols-outlined">
      expand_more
    </span>

  </div>

  <div
    class="language-list"
    *ngIf="showCasteDropdown">

    <input
      type="text"
      class="search-box"
      [(ngModel)]="casteSearch"
      placeholder="Search Caste">

    <div class="dropdown-items">

      <div
        class="language-item"
        (click)="formData.caste='';showCasteDropdown=false">

        No Preference

      </div>

      <div
        class="language-item"
        *ngFor="let cast of filteredCastes()"
        (click)="selectCaste(cast)">

        {{ cast.caste_nme }}

      </div>

    </div>

  </div>

</div>
            </div>
            <div>
              <label class="block text-xs font-semibold text-secondary mb-2">Subcaste Preference</label>
              <div class="custom-dropdown">

  <div
    class="selected-box"
    (click)="showSubcasteDropdown=!showSubcasteDropdown">

    <span>{{ selectedSubcasteName }}</span>

    <span class="arrow material-symbols-outlined">
      expand_more
    </span>

  </div>

  <div
    class="language-list"
    *ngIf="showSubcasteDropdown">

    <input
      type="text"
      class="search-box"
      [(ngModel)]="subcasteSearch"
      placeholder="Search Subcaste">

    <div class="dropdown-items">

      <div
        class="language-item"
        (click)="formData.subcaste='';showSubcasteDropdown=false">

        No Preference

      </div>

      <div
        class="language-item"
        *ngFor="let sub of filteredSubcastes()"
        (click)="selectSubcaste(sub)">

        {{ sub.subcaste_nme }}

      </div>

    </div>

  </div>

</div>
            </div>
            <div>
              <label class="block text-xs font-semibold text-secondary mb-2">Mother Tongue Preference</label>
              <div class="custom-dropdown">

  <div
    class="selected-box"
    (click)="showLanguageDropdown=!showLanguageDropdown">

    <span>{{ selectedLanguageName }}</span>

    <span class="arrow material-symbols-outlined">
      expand_more
    </span>

  </div>

  <div
    class="language-list"
    *ngIf="showLanguageDropdown">

    <input
      type="text"
      class="search-box"
      [(ngModel)]="languageSearch"
      placeholder="Search Language">

    <div class="dropdown-items">

      <div
        class="language-item"
        (click)="formData.motherTongue='';showLanguageDropdown=false">

        No Preference

      </div>

      <div
        class="language-item"
        *ngFor="let lang of filteredLanguages()"
        (click)="selectLanguage(lang)">

        {{ lang.language_nme }}

      </div>

    </div>

  </div>

</div>
            </div>
          </div>

          <!-- Step 3: Education -->
          <div *ngIf="activeStep === 2" class="grid grid-cols-1 sm:grid-cols-1 gap-5 animate-fadeIn">
            <div>
              <label class="block text-xs font-semibold text-secondary mb-2">Preferred Highest Qualification</label>
              <div class="custom-dropdown">

  <div
    class="selected-box"
    (click)="showEducationDropdown=!showEducationDropdown">

    <span>{{ selectedEducationName }}</span>

    <span class="arrow material-symbols-outlined">
      expand_more
    </span>

  </div>

  <div
    class="language-list"
    *ngIf="showEducationDropdown">

    <input
      type="text"
      class="search-box"
      [(ngModel)]="educationSearch"
      placeholder="Search Education">

    <div class="dropdown-items">

      <div
        class="language-item"
        (click)="formData.education='';showEducationDropdown=false">

        No Preference

      </div>

      <div
        class="language-item"
        *ngFor="let edu of filteredEducations()"
        (click)="selectEducation(edu)">

        {{ edu.education_nme }}

      </div>

    </div>

  </div>

</div>
            </div>
            <div>
              <label class="block text-xs font-semibold text-secondary mb-2">Additional / Higher Education</label>
              <div class="custom-dropdown">

  <div
    class="selected-box"
    (click)="showHigherEducationDropdown=!showHigherEducationDropdown">

    <span>{{ selectedHigherEducationName }}</span>

    <span class="arrow material-symbols-outlined">
      expand_more
    </span>

  </div>

  <div
    class="language-list"
    *ngIf="showHigherEducationDropdown">

    <input
      type="text"
      class="search-box"
      [(ngModel)]="higherEducationSearch"
      placeholder="Search Higher Education">

    <div class="dropdown-items">

      <div
        class="language-item"
        (click)="formData.higherEducation='';showHigherEducationDropdown=false">

        No Preference

      </div>

      <div
        class="language-item"
        *ngFor="let edu of filteredHigherEducations()"
        (click)="selectHigherEducation(edu)">

        {{ edu.highereducation_nme }}

      </div>

    </div>

  </div>

</div>
            </div>
          </div>

          <!-- Step 4: Career & Income -->
          <div *ngIf="activeStep === 3" class="grid grid-cols-1 sm:grid-cols-1 gap-5 animate-fadeIn">
            <div class="col-span-2">
              <label class="block text-xs font-semibold text-secondary mb-2">Occupation Sector</label>
              <div class="custom-dropdown">

  <div
    class="selected-box"
    (click)="showOccupationDropdown=!showOccupationDropdown">

    <span>{{ selectedOccupationName }}</span>

    <span class="arrow material-symbols-outlined">
      expand_more
    </span>

  </div>


  <div
    class="language-list"
    *ngIf="showOccupationDropdown">


    <input
      type="text"
      class="search-box"
      [(ngModel)]="occupationSearch"
      placeholder="Search Occupation">


    <div class="dropdown-items">


      <div
        class="language-item"
        (click)="formData.occupation='';showOccupationDropdown=false">

        No Preference

      </div>


      <div
        class="language-item"
        *ngFor="let occ of filteredOccupations()"
        (click)="selectOccupation(occ)">

        {{ occ.occupation_nme }}

      </div>


    </div>


  </div>

</div>
            </div>
            <div class="col-span-2">
              <label class="block text-xs font-semibold text-secondary mb-2">Employment Type</label>
              <div class="custom-dropdown">

  <div
    class="selected-box"
    (click)="showEmploymentDropdown=!showEmploymentDropdown">

    <span>{{ selectedEmploymentName }}</span>

    <span class="arrow material-symbols-outlined">
      expand_more
    </span>

  </div>


  <div
    class="language-list"
    *ngIf="showEmploymentDropdown">


    <input
      type="text"
      class="search-box"
      [(ngModel)]="employmentSearch"
      placeholder="Search Employment Type">


    <div class="dropdown-items">


      <div
        class="language-item"
        (click)="formData.employmentType='';showEmploymentDropdown=false">

        No Preference

      </div>


      <div
        class="language-item"
        *ngFor="let emp of filteredEmployments()"
        (click)="selectEmployment(emp)">

        {{ emp.employment_type_nme }}

      </div>


    </div>


  </div>

</div>
            </div>
            <div class="sm:col-span-2">
              <label class="block text-xs font-semibold text-secondary mb-2">Minimum Salary Expected (Yearly)</label>
              <input
                type="number"
                [(ngModel)]="formData.minSalary"
                class="w-full bg-secondary-container/20 border border-secondary/15 rounded-xl px-3 py-2 text-xs focus:ring-1 focus:ring-primary outline-none"
                placeholder="e.g. 500000"
              />
            </div>
          </div>

          <!-- Step 5: Place/Location -->
          <div *ngIf="activeStep === 4" class="grid grid-cols-1 sm:grid-cols-2 gap-5 animate-fadeIn">
            <div>
              <label class="block text-xs font-semibold text-secondary mb-2">Country of Residence</label>
              <div class="custom-dropdown">

<div class="selected-box"
(click)="showCountryDropdown=!showCountryDropdown">

{{ selectedCountryName || 'No Preference' }}

<span class="arrow material-symbols-outlined">
expand_more
</span>

</div>


<div class="language-list" *ngIf="showCountryDropdown">

<input
class="search-box"
placeholder="Search Country"
[(ngModel)]="countrySearch"
/>


<div class="dropdown-items">


<div
class="language-item"
(click)="formData.country='';showCountryDropdown=false">

No Preference

</div>


<div
class="language-item"
*ngFor="let c of filteredCountries()"
(click)="selectCountry(c)">

{{c.name_0}}

</div>


</div>

</div>

</div>
            </div>
            <div>
              <label class="block text-xs font-semibold text-secondary mb-2">Preferred City</label>
              <div class="custom-dropdown">


  <div
    class="selected-box"
    (click)="showCityDropdown=!showCityDropdown">


    <span>
      {{ selectedCityName  || 'No Preference' }}
    </span>


    <span class="arrow material-symbols-outlined">
      expand_more
    </span>


  </div>




  <div
    class="language-list"
    *ngIf="showCityDropdown">


    <input
      class="search-box"
      placeholder="Search City"
      [(ngModel)]="citySearch"
    />



    <div class="dropdown-items">


      <div
        class="language-item"
        (click)="formData.preferredCity='';showCityDropdown=false">

        No Preference

      </div>




      <div
        class="language-item"
        *ngFor="let c of filteredCities()"
        (click)="selectCity(c)">

        {{c.city_nme}}

      </div>


    </div>


  </div>


</div>
            </div>
            <div>
              <label class="block text-xs font-semibold text-secondary mb-2">State</label>
              <div class="custom-dropdown">

  <div
    class="selected-box"
    (click)="showStateDropdown=!showStateDropdown">

    <span>
      {{ selectedStateName || 'No Preference' }}
    </span>

    <span class="arrow material-symbols-outlined">
      expand_more
    </span>

  </div>


  <div
    class="language-list"
    *ngIf="showStateDropdown">

    <input
      class="search-box"
      placeholder="Search State"
      [(ngModel)]="stateSearch"
    />


    <div class="dropdown-items">


      <div
        class="language-item"
        (click)="formData.state='';formData.district='';formData.preferredCity='';showStateDropdown=false">

        No Preference

      </div>



      <div
        class="language-item"
        *ngFor="let s of filteredStates()"
        (click)="selectState(s)">

        {{s.name_1}}

      </div>


    </div>

  </div>

</div>
            </div>
            <div>
              <label class="block text-xs font-semibold text-secondary mb-2">District</label>
              <div class="custom-dropdown">

  <div
    class="selected-box"
    (click)="showDistrictDropdown=!showDistrictDropdown">


    <span>
      {{ selectedDistrictName || 'No Preference' }}
    </span>


    <span class="arrow material-symbols-outlined">
      expand_more
    </span>


  </div>



  <div
    class="language-list"
    *ngIf="showDistrictDropdown">


    <input
      class="search-box"
      placeholder="Search District"
      [(ngModel)]="districtSearch"
    />



    <div class="dropdown-items">


      <div
        class="language-item"
        (click)="formData.district='';formData.preferredCity='';showDistrictDropdown=false">

        No Preference

      </div>



      <div
        class="language-item"
        *ngFor="let d of filteredDistricts()"
        (click)="selectDistrict(d)">

        {{d.name_2}}

      </div>


    </div>


  </div>


</div>
            </div>
            <div>
              <label class="block text-xs font-semibold text-secondary mb-2">Citizenship</label>
              <select
                [(ngModel)]="formData.citizenship"
                class="w-full bg-secondary-container/20 border border-secondary/15 rounded-xl px-2.5 py-2.5 text-xs focus:ring-1 focus:ring-primary outline-none"
              >
                <option value="">No Preference</option>
                <option *ngFor="let c of citizens" [value]="c._id">{{ c.citizenship_nme }}</option>
              </select>
            </div>
            <div>
              <label class="block text-xs font-semibold text-secondary mb-2">Location Proximity</label>
              <input
                type="text"
                [(ngModel)]="formData.locationProximity"
                class="w-full bg-secondary-container/20 border border-secondary/15 rounded-xl px-3 py-2 text-xs focus:ring-1 focus:ring-primary outline-none"
                placeholder="e.g. Near me"
              />
            </div>
          </div>

          <!-- Step 6: Lifestyle -->
          <div *ngIf="activeStep === 5" class="grid grid-cols-1 sm:grid-cols-1 gap-5 animate-fadeIn">
            <div>
              <label class="block text-xs font-semibold text-secondary mb-2">Dietary preference</label>
              <div class="custom-dropdown">

  <div class="selected-box" (click)="dietOpen = !dietOpen">
    {{ formData.dietPreference || 'No Preference' }}

    <span class="arrow material-symbols-outlined">
      expand_more
    </span>
  </div>


  <div class="custom-dropdown-list" *ngIf="dietOpen">

    <input
      class="search-box"
      placeholder="Search diet..."
      [(ngModel)]="dietSearch"
    />


    <div class="dropdown-items">

      <div
        class="gender-item"
        *ngFor="let item of filteredDietList()"
        (click)="selectDiet(item)"
      >
        {{item}}
      </div>

    </div>

  </div>

</div>
            </div>
            <div>
              <label class="block text-xs font-semibold text-secondary mb-2">Smoking tolerance</label>
              <div class="custom-dropdown">

  <div class="selected-box" (click)="smokingOpen = !smokingOpen">

    {{ formData.smoking || 'No Preference' }}

    <span class="arrow material-symbols-outlined">
      expand_more
    </span>

  </div>


  <div class="custom-dropdown-list" *ngIf="smokingOpen">

    <input
      class="search-box"
      placeholder="Search smoking..."
      [(ngModel)]="smokingSearch"
    />


    <div class="dropdown-items">

      <div
        class="gender-item"
        *ngFor="let item of filteredSmokingList()"
        (click)="selectSmoking(item)"
      >
        {{item}}
      </div>

    </div>

  </div>

</div>
            </div>
            <div>
              <label class="block text-xs font-semibold text-secondary mb-2">Drinking tolerance</label>
              <div class="custom-dropdown">

  <div class="selected-box" (click)="drinkingOpen = !drinkingOpen">

    {{ formData.drinking || 'No Preference' }}

    <span class="arrow material-symbols-outlined">
      expand_more
    </span>

  </div>


  <div class="custom-dropdown-list" *ngIf="drinkingOpen">

    <input
      class="search-box"
      placeholder="Search drinking..."
      [(ngModel)]="drinkingSearch"
    />


    <div class="dropdown-items">

      <div
        class="gender-item"
        *ngFor="let item of filteredDrinkingList()"
        (click)="selectDrinking(item)"
      >
        {{item}}
      </div>

    </div>

  </div>

</div>
            </div>
          </div>

          <!-- Step 7: Stars & Horoscope -->
          <div *ngIf="activeStep === 6" class="grid grid-cols-1 sm:grid-cols-1 gap-5 animate-fadeIn">
            <div *ngIf="isNonReligiousUser" class="p-6 bg-emerald-50 border border-emerald-200 rounded-2xl text-center space-y-2">
              <span class="material-symbols-outlined text-emerald-600 text-3xl">public</span>
              <h4 class="text-base font-bold text-emerald-900 m-0">Astrology Criteria Disabled</h4>
              <p class="text-xs text-emerald-800/90 m-0 leading-relaxed max-w-md mx-auto">
                Because your profile is marked as <strong>Non-Religious / Secular</strong>, horoscope verifications, Kundli matching, Rasi, Natchatra, and Gothram restrictions are automatically bypassed.
              </p>
            </div>
            <ng-container *ngIf="!isNonReligiousUser">
            <div>
              <label class="block text-xs font-semibold text-secondary mb-2">Preferred Rashi / Zodiac</label>
              <div class="custom-dropdown">

  <div class="selected-box" (click)="zodiacOpen = !zodiacOpen">

    {{ getZodiacName() || 'No Preference' }}

    <span class="arrow material-symbols-outlined">
      expand_more
    </span>

  </div>


  <div class="custom-dropdown-list" *ngIf="zodiacOpen">

    <input
      class="search-box"
      placeholder="Search zodiac..."
      [(ngModel)]="zodiacSearch"
    />


    <div class="dropdown-items">

      <div
        class="gender-item"
        *ngFor="let rasi of filteredZodiacList()"
        (click)="selectZodiac(rasi)"
      >
        {{ rasi.rasi_nme }}
      </div>

    </div>

  </div>

</div>
            </div>
            <div>
              <label class="block text-xs font-semibold text-secondary mb-2">Preferred Natchatra</label>
              <div class="custom-dropdown">

  <div class="selected-box" (click)="natchatraOpen = !natchatraOpen">

    {{ getNatchatraName() || 'No Preference' }}

    <span class="arrow material-symbols-outlined">
      expand_more
    </span>

  </div>


  <div class="custom-dropdown-list" *ngIf="natchatraOpen">

    <input
      class="search-box"
      placeholder="Search natchatra..."
      [(ngModel)]="natchatraSearch"
    />


    <div class="dropdown-items">

      <div
        class="gender-item"
        *ngFor="let n of filteredNatchatraList()"
        (click)="selectNatchatra(n)"
      >
        {{n.natchr_nme}}
      </div>

    </div>

  </div>

</div>
            </div>
            <div>
              <label class="block text-xs font-semibold text-secondary mb-2">Manglik Status Preferred</label>
              <div class="custom-dropdown">

  <div class="selected-box" (click)="manglikOpen = !manglikOpen">

    {{formData.manglik || 'No Preference'}}

    <span class="arrow material-symbols-outlined">
      expand_more
    </span>

  </div>


  <div class="custom-dropdown-list" *ngIf="manglikOpen">

    <div class="dropdown-items">

      <div 
        class="gender-item"
        (click)="selectManglik('No')">
        Non-Manglik Only
      </div>

      <div 
        class="gender-item"
        (click)="selectManglik('Yes')">
        Manglik Only
      </div>

      <div 
        class="gender-item"
        (click)="selectManglik('')">
        No Preference
      </div>

    </div>

  </div>

</div>
            </div>
            <div>
              <label class="block text-xs font-semibold text-secondary mb-2">Gothra Preference/Exclusion</label>
              <div class="custom-dropdown">

  <div class="selected-box" (click)="gothraOpen = !gothraOpen">

    {{ getGothraName() || 'No Preference' }}

    <span class="arrow material-symbols-outlined">
      expand_more
    </span>

  </div>


  <div class="custom-dropdown-list" *ngIf="gothraOpen">

    <input
      class="search-box"
      placeholder="Search gothra..."
      [(ngModel)]="gothraSearch"
    />


    <div class="dropdown-items">

      <div
        class="gender-item"
        *ngFor="let g of filteredGothraList()"
        (click)="selectGothra(g)"
      >
        {{g.gothram_nme}}
      </div>

    </div>

  </div>

</div>
            </div>
            </ng-container>
          </div>

        </div>

        <!-- Stepper Buttons and navigation indicators -->
        <div class="partner-navigation flex justify-between items-center pt-4 border-t border-secondary/5 font-semibold text-xs text-secondary">
          <button
            (click)="handleBack()"
            [disabled]="activeStep === 0"
            class="px-4 py-2 border border-secondary/20 rounded-xl flex items-center gap-1.5 transition-all bg-transparent"
            [ngClass]="activeStep === 0 ? 'opacity-30 cursor-not-allowed' : 'hover:border-primary hover:text-primary active:scale-95'"
          >
            <span class="material-symbols-outlined text-sm">arrow_back</span>
            Back
          </button>

          <!-- Pagination dots -->
          <div class="hidden sm:flex items-center space-x-2">
            <div
              *ngFor="let s of steps; let i = index"
              class="h-2 rounded-full transition-all duration-300"
              [ngClass]="i === activeStep ? 'w-6 bg-primary' : 'w-2 bg-secondary/35'"
            ></div>
          </div>

          <div class="flex items-center gap-2">
            <button
              *ngIf="activeStep !== steps.length - 1"
              (click)="saveSectionProgress()"
              [disabled]="isSaving"
              class="px-4 py-2 border border-primary/20 text-primary hover:bg-primary/5 rounded-xl flex items-center gap-1.5 transition-all active:scale-95 text-center"
            >
              <span class="material-symbols-outlined text-sm">save</span>
              {{ isSaving ? 'Saving...' : 'Save Progress' }}
            </button>
            <button
              (click)="handleNext()"
              class="px-5 py-2 bg-primary hover:bg-primary-container text-white rounded-xl flex items-center gap-1.5 transition-all shadow-md active:scale-95 text-center border-0"
            >
              {{ activeStep === steps.length - 1 ? 'Save All & Match' : 'Continue' }}
              <span class="material-symbols-outlined text-sm" *ngIf="activeStep !== steps.length - 1">arrow_forward</span>
              <span class="material-symbols-outlined text-sm" *ngIf="activeStep === steps.length - 1">check_circle</span>
            </button>
          </div>
        </div>

      </div>
    </div>
  </ng-container>
</div>
